import accountService from '../../../redux/services/accountService';

// eslint-disable-next-line import/prefer-default-export
export const deleteMyAccount = () => () => accountService
  .deleteMyAccount()
  .then(response => response)
  .catch(error => error);
